import React, { useContext, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../GlobalContext';
import '../styles/auth.css';

export default function Signup() {
    const { setUser } = useContext(GlobalContext);
    const [suser, setSUser] = useState('');
    const [pass, setPass] = useState('');
    const [msg, setMsg] = useState('');
    const [disp, setDisp] = useState(false);
    const [loading, setLoading] = useState(false);

    const hasUpperCase = (str) => /[A-Z]/.test(str);
    const hasLowerCase = (str) => /[a-z]/.test(str);
    const hasNumber = (str) => /[0-9]/.test(str);
    const hasSpecialCharac = (str) => /[!@#$%^&*]/.test(str);
    const navigate = useNavigate();

    const check_pass = (pass, user) => {
        if (hasUpperCase(pass) && hasLowerCase(pass) && hasNumber(pass) && hasSpecialCharac(pass)) {
            return true;
        }
        return false;
    }

    const handleDetails = (e, t) => {
        setDisp(false);
        setMsg('');
        if (t === 'user') {
            setSUser(e.target.value);
        }
        else {
            setPass(e.target.value);
        }
    }

    const handleReg = async () => {
        if (check_pass(pass) && suser.includes("@")) {
            try {
                localStorage.clear();
                await axios.post(`${process.env.REACT_APP_API_URL}/signup`, {
                    username: suser,
                    password: pass
                }, {
                    withCredentials: true
                });
                localStorage.setItem('user', `${suser.slice(0, suser.indexOf("@"))}`);
                setUser(suser.slice(0, suser.indexOf("@")));
                setLoading(true);
                setTimeout(() => {
                    navigate('/dashboard');
                }, 3000);

            }
            catch (err) {
                setDisp(true);
                if (err.message.includes('401')) {
                    setMsg('User already exists');
                }
                else {
                    setMsg('Internal Server Error');
                }
            }
        }
        else {
            setDisp(true);
            if(!suser.includes("@") && pass && suser) {
                setMsg("Please provide a valid email");
            }
            else if(!check_pass(pass) && pass && suser) {
                setMsg("The password must have atleast one uppercase, one lowercase letter, one number, one special character")
            }
            else {
                setMsg("Please enter all details");
            }
        }
    }

    return (
        <div className='auth-container'>
            <div className='auth-card-container'>
                <h1 className='auth-title'>Signup</h1>
                <input id='email' type='email' placeholder='johndoe@gmail.com' onChange={(e) => handleDetails(e, 'user')} className='auth-inputs' />
                <input id='password' type='password' placeholder='password' onChange={handleDetails} className='auth-inputs' />
                <button onClick={handleReg} className='auth-btns'>Register</button>
                <a href='/'>Login</a>
                {loading ?
                    <div className="spinner-border text-dark" role="status" style={{marginTop: "5vh"}}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    : null
                }
                {disp && (
                    <div className="alert alert-danger auth-alerts-container" role="alert">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="" viewBox="0 0 16 16" role="img" aria-label="Warning:" style={{ height: "3.5vh", marginRight: "1vw" }}>
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                        </svg>
                        <div style={{ display: "inline-block"}}>
                            {msg}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}